export default "__VITE_ASSET__BlVTVf_n__"